import React from 'react';
import { Box } from '@mui/material';
import Header from '../../../src/components/Header';
import Footer from '../../../src/components/Footer';
import Hero from './Hero';
import Content from './Content';

function Home() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // Ensures the entire viewport height is used
            }}
        >
            {/* Header */}
            <Header />

            {/* Main Content */}
            <Box sx={{ flexGrow: 1 }}> {/* Allows the main content to grow and push the footer */}
                <Hero />
                <Content />
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
}

export default Home;
